import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import { withRouter } from 'react-router-dom'

const styles = {
  heading: {
    fontFamily: 'Lato',
    fontWeight: 'bold',
    color: 'var(--color-text-primary)',
    marginBottom: 8,
  },
}

class Heading extends React.Component {
  render() {
    const { classes, children, fontSize } = this.props

    return (
      <h2 className={classes.heading} style={{ fontSize: fontSize || 24 }}>
        {children}
      </h2>
    )
  }
}

Heading.propTypes = {
  classes: PropTypes.object.isRequired,
  children: PropTypes.node.isRequired,
  fontSize: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}

export default withRouter(withStyles(styles)(Heading))